


















































import { Component, Vue, Prop, Emit, Watch } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import SolicitacaoCirurgiaStore from '@/components/SolicitacaoCirurgia/store/SolicitacaoCirurgiaStore'
import { timeout } from '@/utils/common'

@Component
export default class ComponentModalConfirmarPreviaCirurgica extends Vue {
  @Prop({ required: true, default: { prazoEmDiasParaTriagem: 0, prazoMaximoEmDiasParaAgendamento: 0 } }) configuracoes: any
  @Prop({ required: true, default: false }) loadingState: boolean

  get getSolicitacaoCirurgiaStore() {
    return getModule(SolicitacaoCirurgiaStore, this.$store)
  }

  get previaCirurgica() {
    return this.getSolicitacaoCirurgiaStore.modal.previaCirurgica
  }

  set previaCirurgica(value: boolean) {
    this.getSolicitacaoCirurgiaStore.setModal({ name: 'previaCirurgica', value })
  }

  @Emit('confirmar')
  confirmar() {}

  @Watch('previaCirurgica')
  onChangePreviaCirurgica(value) {
    //
  }
}
